import React, { ComponentType } from 'react'

type FunctionPermission = (data: {
  user: any
  organization?: any
  isInternal?: boolean
}) => boolean

type FunctionPermissions = FunctionPermission[]

export interface RouteConfig {
  path: string
  component: ComponentType<any>
  auth?: string[]
  label?: React.ReactNode
  isConditionable?: boolean
  isTranslatable?: boolean
  id?: string
  showCollapseBtn?: boolean
  collapseByDefault?: boolean
  errorRedirectPath?: string
  inOneOfGroups?: string[]
  functionPermissions?: FunctionPermissions
  env?: string[]
  exact?: boolean
  render?: (props: any) => React.ReactElement
  settings?: any
}

export interface MatchProps<Params = { id: string }> {
  match: {
    params: Params
  }
}

export interface NavigationItem {
  name: React.ReactNode
  path?: string
  icon?: React.ReactNode
  iconText?: React.ReactNode
  datatut?: string
  auth?: string[]
  inOneOfGroups?: string[]
  functionPermissions?: FunctionPermissions
  env?: string[]
  children?: NavigationItem[]
}

// function to match the route with the path
export function matchPath (route: string, currentPathname: string): boolean {
  // Split the route and path into parts
  const routeParts = (route ?? '')
    .split('/')
    .filter((part) => part !== '')
  const pathParts = (currentPathname ?? '')
    .split('/')
    .filter((part) => part !== '')
  // Loop through each part of the route
  for (let i = 0; i < routeParts.length; i++) {
    const routePart: String = routeParts[i]
    const pathPart: String = pathParts[i]
    if (routePart.startsWith(':')) {
      if (routePart.endsWith('?')) {
        continue
      }
      if (pathPart == null) {
        return false
      }
    } else if (routePart !== pathPart) {
      return false
    }
  }
  return true
}
